import styled, { css } from 'styled-components';
import { Property } from 'csstype';

import { GetSCProps } from '@utils/types';

type FlexibleDivProps = GetSCProps<'left' | 'right' | 'top' | 'bottom'>;

export enum SeparatorSize {
  SMALL = '10px',
  MIDDLE = '20px',
  LARGE = '40px',
}

export const Layout = styled.div`
  max-width: 1240px;
  height: auto;
  margin: 0 auto;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.DESKTOP})`} {
    margin: 0;
    width: 100%;
  }
`;

type CustomSpacing = `${number}px`;
export const Separator = styled.div<{ size?: SeparatorSize | CustomSpacing }>`
  margin-top: ${({ size }) => size || SeparatorSize.MIDDLE};
`;

export const SimpleButton = styled.button`
  background: none;
  color: inherit;
  border: none;
  padding: 0;
  font: inherit;
  outline: inherit;
  cursor: pointer;
`;
export const SimpleButtonQuality = styled.button`
  margin: 29px 357px 0 292px;
  padding: 18px 39px 17px 40px;
  border-radius: 2px;
  border: solid 1px ${({ theme }) => theme.palette.eclipse};
  background-color: transparent;
  font-size: 18px;
  display: flex;
  align-items: center;
  font-weight: bold;
`;
export const ButtonText = styled.span`
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: ${({ theme }) => theme.palette.eclipse};
`;

export const Row = styled.div<{
  alignItems?: Property.AlignItems;
  justifyContent?: Property.JustifyContent;
}>`
  display: flex;
  flex-direction: row;
  ${({ alignItems }) =>
    alignItems &&
    css`
      align-items: ${alignItems};
    `};
  ${({ justifyContent }) =>
    justifyContent &&
    css`
      justify-content: ${justifyContent};
    `};
`;

export const Col = styled.div<{
  alignItems?: Property.AlignItems;
  justifyContent?: Property.JustifyContent;
}>`
  display: flex;
  flex-direction: column;
  ${({ alignItems }) =>
    alignItems &&
    css`
      align-items: ${alignItems};
    `};
  ${({ justifyContent }) =>
    justifyContent &&
    css`
      justify-content: ${justifyContent};
    `};
`;

export const FlexibleDiv = styled.div<FlexibleDivProps>`
  margin-left: ${({ left }) => left || 0}px;
  margin-right: ${({ right }) => right || 0}px;
  margin-top: ${({ top }) => top || 0}px;
  margin-bottom: ${({ bottom }) => bottom || 0}px;
`;

export const FormHelperText = styled.p`
  color: rgba(0, 0, 0, 0.6);
  font-weight: 400;
  font-size: 0.75rem;
  line-height: 1.66;
  letter-spacing: 0.03333em;
  text-align: left;
  margin-top: 3px;
  margin-right: 0;
  margin-bottom: 0;
  margin-left: 0;
`;
